import { createContext } from "react";
import type { CsatInputs } from "./csat-form";
import type { CsatSurveyMessageEditor } from "./hooks/use-csat-survey-message-editor";
import type { CsatSurveyTemplateCatalog } from "./hooks/use-csat-survey-templates";

/**
 * What the CSAT pages need from the shared form shell, so they work the same
 * whether the shell mounts them as routed sub-pages or as tabs.
 */
export interface CsatSettingsContextValue {
  inputs: CsatInputs;
  templates: CsatSurveyTemplateCatalog;
  editor: CsatSurveyMessageEditor;
  canManageSupportSettings: boolean;
  openPreview: (templateId: string | undefined) => void;
}

export const CsatSettingsContext = createContext<
  CsatSettingsContextValue | undefined
>(undefined);
